import { render, staticRenderFns } from "./AIAnswerInput.vue?vue&type=template&id=659e69ca&scoped=true"
import script from "./AIAnswerInput.vue?vue&type=script&lang=js"
export * from "./AIAnswerInput.vue?vue&type=script&lang=js"
import style0 from "./AIAnswerInput.vue?vue&type=style&index=0&id=659e69ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659e69ca",
  null
  
)

export default component.exports